export enum TabsType {
  Overview = 'overview',
  Financials = 'financials',
  Chart = 'chart',
  Connections = 'connections',
  NewsInsights = 'newsInsights',
  Documents = 'documents',
  Earnings = 'earnings',
}
